//helpers.js
// helpers.js
import React, { useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { UserContext } from "../Context/Context";
import Swal from "sweetalert2";
import fondoBlanco from "../../assets/fondoblanco.jpg";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { AccessTime, Check, Close } from "@mui/icons-material";
import api from "../../api/axios";
import { Box, Button } from "@mui/material";

/**
 * NavButton — renders as <a> so middle-click / Ctrl+click opens a new tab,
 * while a plain left-click still calls the provided onClick (e.g. Swal confirm + navigate).
 */
export const NavButton = ({ to, onClick, children, ...rest }) => (
  <Button
    component="a"
    href={to}
    onClick={(e) => {
      if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
        e.preventDefault();
        onClick?.();
      }
    }}
    {...rest}
  >
    {children}
  </Button>
);

export const CommonSubHeader = ({ title, subTitle = "", specialRute = "" }) => {
  const { userData } = useContext(UserContext);
  const location = useLocation();
  const isReportsSubHeader = location.pathname.startsWith("/informes");

  const sectionPalette = (() => {
    if (location.pathname.startsWith("/contactos")) {
      return {
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,1) 100%)",
        border: "rgba(59, 130, 246, 0.12)",
        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
        title: "#0f3dbf",
        nav: "#1d4ed8",
        text: "#1e3a8a",
        current: "#0f172a",
      };
    }

    if (location.pathname.startsWith("/clientes")) {
      return {
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,1) 100%)",
        border: "rgba(245, 158, 11, 0.14)",
        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
        title: "#9a4a00",
        nav: "#b45309",
        text: "#7c2d12",
        current: "#0f172a",
      };
    }

    if (location.pathname.startsWith("/expedientes")) {
      return {
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,1) 100%)",
        border: "rgba(34, 197, 94, 0.14)",
        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
        title: "#0f7a3a",
        nav: "#15803d",
        text: "#14532d",
        current: "#0f172a",
      };
    }

    return {
      background: "linear-gradient(135deg, #f8fafc, #eef2ff)",
      border: "#e2e8f0",
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
      title: "#0f172a",
      nav: "#2563eb",
      text: "#475569",
      current: "#0f172a",
    };
  })();

  const reportsStyle = {
    position: "relative",
    background:
      "linear-gradient(135deg, rgba(15,23,42,0.96), rgba(17,24,39,0.94))",
    border: "1px solid rgba(96,165,250,0.25)",
    boxShadow: "0 16px 40px rgba(59,130,246,0.12)",
  };

  const defaultStyle = {
    position: "relative",
    background: sectionPalette.background,
    border: "1px solid rgba(148, 163, 184, 0.18)",
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.04)",
    padding: "14px 21px",
  };

  const titleColor = isReportsSubHeader ? "#e2e8f0" : "#111827";
  const navColor = isReportsSubHeader ? "#93c5fd" : "#1f2937";
  const textColor = isReportsSubHeader ? "#cbd5e1" : "#374151";
  const currentTextColor = isReportsSubHeader ? "#f8fafc" : "#111827";

  return (
    <Box
      className="viewHead"
      style={isReportsSubHeader ? reportsStyle : defaultStyle}
    >
      <Box className="titleContainer" sx={{ mb: 0.8 }}>
        <span
          className="title"
          style={{
            color: titleColor,
            fontWeight: 600,
            fontSize: "16px",
          }}
        >
          {title}
        </span>
      </Box>
      <Box
        className="paragraph"
        style={{
          color: textColor,
          fontSize: "13px",
          marginLeft: 0,
        }}
      >
        <NavLink
          className="urlDirection"
          to="/panel"
          style={{ color: navColor, fontWeight: 500 }}
        >
          Inicio
        </NavLink>{" "}
        {title && subTitle !== "" ? (
          <>
            /{" "}
            {title == "Configuración" ? (
              <span style={{ color: titleColor }}>{title} / </span>
            ) : (
              <NavLink
                className="urlDirection"
                to={`/${(specialRute ? specialRute : title)?.toLowerCase()}`}
                style={{ color: navColor, fontWeight: 500 }}
              >
                {title} /
              </NavLink>
            )}{" "}
            <b style={{ color: currentTextColor }}>{subTitle}</b>
          </>
        ) : (
          <b style={{ color: currentTextColor }}>/ {title}</b>
        )}
      </Box>
      <Box
        sx={{
          paddingRight: "20px",
          position: "absolute",
          right: "0px",
          top: "15px",
        }}
      >
        <ImageCell userCompany={userData.userCompany} />
      </Box>
    </Box>
  );
};

const ImageCell = ({ userCompany }) => {
  const { companyImageRealTime } = useContext(UserContext);
  // Determina la URL base
  let urlReturn = process.env.REACT_APP_BACKEND_HOST;

  // Comprobaciones para generar la URL de la imagen
  const imageUrl = companyImageRealTime
    ? `${urlReturn}/storage/company/${userCompany?.id}/${companyImageRealTime}`
    : userCompany?.company_logo
      ? `${urlReturn}/storage/company/${userCompany.id}/${userCompany.company_logo}`
      : fondoBlanco;

  return (
    <img
      src={imageUrl}
      alt={
        userCompany?.name
          ? `Logo de ${userCompany.name}`
          : "Logo de la compañía"
      }
      onError={(e) => (e.target.src = fondoBlanco)} // Muestra un fondo si falla la carga
      style={{ height: "50px", objectFit: "contain", borderRadius: "10px" }} // Asegura que la imagen no se deforme
    />
  );
};

export default ImageCell;

// url api
export const getUrl = () => {
  return process.env.REACT_APP_BACKEND_HOST || "";
};

// DECODING EXISTING CONTRACT (Si ya existe un contrato firmado)
export const extractContractPayload = (input) => {
  if (input === null || input === undefined) {
    return "";
  }

  if (typeof input === "object") {
    if (typeof input.firma === "string") {
      return input.firma;
    }

    if (typeof input?.firma === "number") {
      return String(input.firma);
    }

    return "";
  }

  const value = String(input).trim();

  if (!value) {
    return "";
  }

  const normalizedValue = value.replace(/\\"/g, '"');
  const serializedMatch = normalizedValue.match(
    /s:5:"firma";s:\d+:"([\s\S]*?)(?:";|\})/,
  );

  if (serializedMatch && serializedMatch[1] !== undefined) {
    let candidate = serializedMatch[1].replace(/^"+|"+$/g, "");

    if (!candidate || candidate === '""' || candidate === "''") {
      return "";
    }

    return candidate;
  }

  if (
    /a:0:\{\}/i.test(normalizedValue) ||
    /s:5:"firma";s:\d+:""/i.test(normalizedValue)
  ) {
    return "";
  }

  return value;
};

export const b64DecodeUnicode = (str) => {
  const source = extractContractPayload(str);

  if (!source) {
    return "";
  }

  try {
    const decoded = atob(source);

    return decodeURIComponent(
      Array.prototype.map
        .call(
          decoded,
          (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2),
        )
        .join(""),
    );
  } catch (error) {
    return String(source);
  }
};

export const hasValidContractConfig = (config) => {
  const rawValue = extractContractPayload(config);

  if (!rawValue) {
    return false;
  }

  const normalized = String(rawValue).trim();
  return normalized !== '""' && normalized !== "''" && normalized !== "a:0:{}";
};
// DECODING EXISTING CONTRACT

export const CustomIcons = ({ icon: Icon, width, height, marginRight }) => {
  return (
    <Icon
      style={{
        width: width ? width : "0",
        height: height ? height : "0",
        marginRight: marginRight ? marginRight : "0",
      }}
    />
  );
};

export const formatToTenDigits = (number) => {
  return number.toString().padStart(10, "0");
};

export const getS3Url = () => {
  const s3Url = process.env.REACT_APP_S3_API_URL || "";

  try {
    return new URL(s3Url).hostname.split(".")[0] || "";
  } catch (error) {
    return "";
  }
};

export const encodeS3Path = (path) => {
  const parts = path.split("/");
  return parts
    .map((part, idx) => {
      const encoded = encodeURIComponent(part);
      if (idx < parts.length - 1) {
        // Carpeta: cambia espacios por '+'
        return encoded.replace(/%20/g, "+");
      } else {
        // Archivo: codificar normalmente, sin doble codificar
        return encoded;
      }
    })
    .join("/");
};

// cookie api
export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
};

export const status = ($txt, $status) => {
  const messages = {
    0: " Pendiente",
    1: " Completa",
    2: " Cancelada",
    3: " Ganado Finalizado",
    4: " Caso cerrado",
    5: " Ganado no Finalizado",
  };

  const key = String($status ?? "");
  if (Object.prototype.hasOwnProperty.call(messages, key)) {
    return `${$txt}${messages[key]}`;
  }

  return "";
};

// Configuración de estados
export const statusConfig = [
  {
    icon: AccessTime,
    severity: "warning",
    text: (name) => `Pendiente ${name}`,
    status: 0,
  },
  {
    icon: Check,
    severity: "success",
    variant: "filled",
    text: (name) => `${name} Completo/a`,
    status: 1,
  },
  {
    icon: Close,
    severity: "error",
    variant: "filled",
    text: (name) => `${name} Cancelado/a`,
    status: 2,
  },
  {
    icon: Check,
    severity: "info",
    variant: "filled",
    text: (name) => `${name} Ganado`,
    status: 3,
  },
  {
    icon: Close,
    severity: "none",
    variant: "filled",
    text: (name) => `${name} Caso cerrado`,
    status: 4,
  },
  {
    icon: AccessTime,
    severity: "info",
    variant: "filled",
    text: (name) => `${name} Ganado`,
    status: 5,
  },
];

export async function getInfoMessageNoResultsSearch(
  title,
  text,
  icon,
  toast,
  confirmText,
  denyState,
) {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonColor: "#1ab394",
    cancelButtonColor: "#d33",
    reverseButtons: true,
    // html:'',
    showDenyButton: denyState,
    // showCancelButton: true,
    confirmButtonText: "<span id=buttomVale>" + confirmText + "</span>",
    toast: toast,
    // denyButtonText: `Cancelar`,
    // preConfirm: (login) => {}
  });
}

// export const logoutMessage = () => {

//   const navigate = useNavigate();

//   Swal.fire({
//     icon: "warning",
//     title: "Sesión expirada",
//     text: "Tu sesión ha caducado, por favor vuelve a iniciar sesión.",
//     showCancelButton: false,
//     confirmButtonColor: "#1ab394",
//     confirmButtonText: "Logearse",
//     allowOutsideClick: false,
//     allowEscapeKey: false,
//     preConfirm: async () => {
//       try {
//         // Llamamos al endpoint de logout en backend usando cookies HttpOnly
//         await api.post("/logout");

//         // Limpiar cualquier almacenamiento local del frontend
//         sessionStorage.clear();
//         localStorage.clear();

//         // Redirigir al login o home
//         navigate("/");
//       } catch (err) {
//         console.error("Error durante logout", err);
//         Swal.showValidationMessage(
//           "No se pudo cerrar sesión, intenta nuevamente."
//         );
//       }
//     },
//   });
// };

export const useLocationHelpers = () => {
  const navigate = useNavigate();

  const goPanel = () => {
    Swal.fire({
      title: "¿Ir al panel?",
      icon: "question",
      showDenyButton: true,
      confirmButtonText: "Sí",
      denyButtonText: "No",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) navigate("/panel");
    });
  };

  const goEdit = (route, id) => {
    Swal.fire({
      title: "¿Ir a editar elemento?",
      icon: "question",
      confirmButtonText: "Sí",
      denyButtonText: "No",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      showDenyButton: true,
    }).then((result) => {
      if (result.isConfirmed) navigate(`/${route}/editar?id=${id}`);
    });
  };

  const goTransfer = (route, id) => {
    Swal.fire({
      title: "¿Transferir elemento?",
      icon: "question",
      confirmButtonText: "Sí",
      denyButtonText: "No",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      showDenyButton: true,
    }).then((result) => {
      if (result.isConfirmed) navigate(`/${route}/transferir?id=${id}`);
    });
  };

  const goView = (name, id, accent = null) => {
    const pluralName =
      name === "asociaciones" || name === "biblioteca" ? name : `${name}s`;
    const titleText = `¿Ir a ver ${accent || name}?`;
    const url = `/${pluralName}/ver?id=${id}`;

    Swal.fire({
      title: titleText,
      icon: "question",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Sí",
      denyButtonText: "No",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        navigate(url);
      }
    });
  };

  const goTable = (name, displayName = null) => {
    Swal.fire({
      title: `¿Volver a la tabla de ${displayName || name}?`,
      showDenyButton: true,
      icon: "question",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Sí",
      denyButtonText: "No",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) navigate(`/${name}`);
    });
  };

  /* --- URL builders (mirror internal logic of goView / goEdit / goTable) --- */
  const buildViewUrl = (name, id) => {
    const pluralName =
      name === "asociaciones" || name === "biblioteca" ? name : `${name}s`;
    return `/${pluralName}/ver?id=${id}`;
  };

  const buildEditUrl = (route, id) => `/${route}/editar?id=${id}`;

  const buildTableUrl = (name) => `/${name}`;

  return {
    goPanel,
    goEdit,
    goView,
    goTable,
    goTransfer,
    buildViewUrl,
    buildEditUrl,
    buildTableUrl,
  };
};

export const formatDate = (defaultDate) => {
  console.log(defaultDate);
  if (defaultDate) {
    // agrega la hora actual
    const dateWithTime = defaultDate
      ?.hour(dayjs()?.hour())
      ?.minute(dayjs()?.minute())
      ?.second(dayjs()?.second());

    // convierte a string
    const formattedDate = dateWithTime.format("YYYY-MM-DD HH:mm:ss");

    // guarda ambas versiones
    const dates = [formattedDate, dateWithTime];

    console.log(dates);

    return dates;
  }
};

export const buildMessageHistory = (prevMessage, newMessage) => {
  if (!prevMessage) return newMessage;

  return `${prevMessage}${newMessage}`;
};

export const formatDateWithoutHour = (defaultDate, mode = "normal") => {
  if (!defaultDate) return null;

  let date = defaultDate;
  let formattedDate = "";

  if (mode === "desde" || mode === "hasta") {
    if (mode === "desde") {
      date = defaultDate.hour(0).minute(0).second(0);
    }

    if (mode === "hasta") {
      date = defaultDate.hour(23).minute(59).second(59);
    }

    formattedDate = date.format("YYYY-MM-DD HH:mm:ss");
  } else if (mode === "normal") {
    formattedDate = defaultDate.format("YYYY-MM-DD");
  } else {
    formattedDate = defaultDate.format("YYYY-MM-DD HH:mm:ss");
  }

  return formattedDate;
};

export const handleDates = (date) => {
  var dateFormated;
  if (date) {
    dateFormated = date?.format("YYYY-MM-DD HH:mm:ss");
  } else {
    dateFormated = null;
  }
  return dateFormated;
};

export const dateFormat = (date) => {
  return date ? dayjs(date).format("DD/MM/YYYY HH:mm:ss") : "-";
};

export const quitarTildes = (str) => {
  return str
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
};

export const normalizeText = (text) => {
  return (text || "")
    .trim()
    .toLowerCase()
    .replace(/<br\s*\/?>/gi, "\n");
};

const normalizeJSON = (obj) => JSON.stringify(obj, Object.keys(obj).sort());

export const normalizeTextPlus = (text) => {
  return (text || "")
    .trim() // Quita espacios al inicio y final
    .replace(/<br\s*\/?>/gi, "\n") // Convierte <br> en saltos de línea
    .replace(/\r\n|\r/g, "\n") // Normaliza saltos de línea Windows/Mac a \n
    .replace(/\s+/g, " ") // Convierte múltiples espacios en uno solo
    .toLowerCase(); // Minúsculas para comparación insensible
};

export const normalizeTextWithoutReplace = (text) => {
  return (text || "").trim().toLowerCase();
};

// Convierte <br> legado a saltos de linea y colapsa lineas en blanco excesivas (evita bloqueos de WAF por HTML crudo)
export const normalizeMultilineText = (text) => {
  return (text || "")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/\r\n|\r/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

// validar email
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const getOptionKey = (option) => {
  if (!option) return "empty";

  if (option.id !== undefined && option.id !== null) {
    return option.id;
  }

  // fallback genérico (por si vienen listas raras)
  return JSON.stringify(option);
};

// export const SwitchStyled = styled(Switch)(({ theme }) => ({
//   padding: 8,
//   '& .MuiSwitch-track': {
//     borderRadius: 22 / 2,
//     '&::before, &::after': {
//       content: '""',
//       position: 'absolute',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       width: 16,
//       height: 16,
//     },
//     '&::before': {
//       backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
//         theme.palette.getContrastText(theme.palette.primary.main),
//       )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
//       left: 22,
//     },
//     '&::after': {
//       backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
//         theme.palette.getContrastText(theme.palette.primary.main),
//       )}" d="M19,13H5V11H19V13Z" /></svg>')`,
//       right: 22,
//     },
//   },
//   '& .MuiSwitch-thumb': {
//     boxShadow: 'none',
//     width: 16,
//     height: 16,
//     margin: 2,
//   },
// }));

// export const SwitchStyled = styled((props) => (
//   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//   width: 42,
//   height: 26,
//   padding: 0,
//   '& .MuiSwitch-switchBase': {
//     padding: 0,
//     margin: 2,
//     transitionDuration: '300ms',
//     '&.Mui-checked': {
//       transform: 'translateX(16px)',
//       color: '#fff',
//       '& + .MuiSwitch-track': {
//         backgroundColor: '#65C466',
//         opacity: 1,
//         border: 0,
//         ...theme.applyStyles('dark', {
//           backgroundColor: '#2ECA45',
//         }),
//       },
//       '&.Mui-disabled + .MuiSwitch-track': {
//         opacity: 0.5,
//       },
//     },
//     '&.Mui-focusVisible .MuiSwitch-thumb': {
//       color: '#33cf4d',
//       border: '6px solid #fff',
//     },
//     '&.Mui-disabled .MuiSwitch-thumb': {
//       color: theme.palette.grey[100],
//       ...theme.applyStyles('dark', {
//         color: theme.palette.grey[600],
//       }),
//     },
//     '&.Mui-disabled + .MuiSwitch-track': {
//       opacity: 0.7,
//       ...theme.applyStyles('dark', {
//         opacity: 0.3,
//       }),
//     },
//   },
//   '& .MuiSwitch-thumb': {
//     boxSizing: 'border-box',
//     width: 22,
//     height: 22,
//   },
//   '& .MuiSwitch-track': {
//     borderRadius: 26 / 2,
//     backgroundColor: '#E9E9EA',
//     opacity: 1,
//     transition: theme.transitions.create(['background-color'], {
//       duration: 500,
//     }),
//     ...theme.applyStyles('dark', {
//       backgroundColor: '#39393D',
//     }),
//   },
// }));
